import { deloc } from "./locale";

/** Extract display title from document content blocks */
export function extractTitle(data: any, contentType: string): string {
  if (contentType === "tips") {
    return deloc(data.title) || "Untitled tip";
  }
  if (contentType === "mealplans" && data.meta?.title) {
    return deloc(data.meta.title);
  }
  if (contentType === "workouts" && data.preview?.title) {
    return deloc(data.preview.title);
  }

  const content = data.content;
  if (!content || !Array.isArray(content)) return data.id || "Untitled";

  for (const block of content) {
    if (block.type === "title" && block.text) {
      const t = typeof block.text === "object" ? (block.text.en || "") : block.text;
      return t.replace(/^#+\s*/, "") || "Untitled";
    }
    if (block.type === "group" && Array.isArray(block.content)) {
      for (const inner of block.content) {
        if (inner.type === "title" && inner.text) {
          const t = typeof inner.text === "object" ? (inner.text.en || "") : inner.text;
          return t.replace(/^#+\s*/, "") || "Untitled";
        }
      }
    }
  }

  return "Untitled";
}

/** Extract thumbnail storage path from document */
export function extractThumbPath(data: any, contentType: string): string | null {
  if (data.images && Array.isArray(data.images) && data.images.length > 0) {
    const first = data.images[0];
    if (first.thumb_url && first.thumb_url !== "AUTO_THUMB_NAME") return first.thumb_url;
    if (first.url && first.url !== "AUTO_IMAGE_NAME") return first.url;
  }
  if (contentType === "workouts" && data.preview?.image) {
    return data.preview.image;
  }
  return findFirstImagePath(data.content || []);
}

function findFirstImagePath(blocks: any[]): string | null {
  for (const block of blocks) {
    if (!block) continue;
    if (block.type === "image") {
      if (block.thumb_url && block.thumb_url !== "AUTO_THUMB_NAME") return block.thumb_url;
      if (block.url && block.url !== "AUTO_IMAGE_NAME") return block.url;
    }
    if (block.type === "group" && Array.isArray(block.content)) {
      const found = findFirstImagePath(block.content);
      if (found) return found;
    }
  }
  return null;
}
